import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

export interface DrawerProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  scrollable?: boolean;
  size?: 'sm' | 'lg' | 'xl';
  position?: 'left' | 'right';
  show: boolean;
  id?: string;
  onHide: () => void;
}

export const Drawer = ({
  show,
  onHide,
  position = 'left',
  size,
  children,
  title,
  id,
  scrollable,
}: DrawerProps) => {
  return (
    <Modal
      id={id}
      show={show}
      onHide={onHide}
      size={size}
      scrollable={scrollable}
      backdrop
      centered={false}
      className={`side-modal-${position}`}
      dialogClassName={`side-modal-dialog`}
    >
      <Button
        className={`position-absolute top-0 ${position === 'left' ? 'end' : 'start'}-0 m-3 px-2 z-3`}
        variant="secondary"
        onClick={onHide}
      >
        <FontAwesomeIcon icon={position === 'left' ? faArrowLeft : faArrowRight} />
      </Button>

      {title && (
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};
